<template>
  <div class="relative" ref="">
    <label v-if="title" class="block text-sm mb-1">
      {{ title }}
      <span v-if="required" class="text-red-500">*</span>
    </label>
    <button
      type="button"
      :disabled="loading"
      @click="isOpen = !isOpen"
      name="Select"
      :class="[
        loading ? 'cursor-not-allowed' : 'cursor-pointer',
        isOpen ? 'outline-primary-blue' : 'outline-transparent',
      ]"
      class="bg-gray-100/75 outline-2 rounded-lg w-full flex items-center justify-between px-3.5 h-12 text-[15px]"
    >
      <div
        class="flex items-center space-x-2 w-full"
        v-if="selectedItems?.length"
      >
        <div
          @click.stop="selectItem(s)"
          class="px-2 py-1 bg-gray-200 hover:bg-rose-600 hover:text-white transition-all duration-300 text-xs whitespace-nowrap rounded-full flex items-center space-x-1"
          v-for="(s, i) in selectedItems.slice(0, 2)"
          :key="s.key || i"
        >
          <span>{{ handleTitle(s.label[locale]) }}</span>
          <button :disabled="loading">
            <Icon
              name="ph:x"
              size="13"
              class="hover:text-primary-blue cursor-pointer flex items-center justify-center"
            />
          </button>
        </div>

        <div
          v-if="selectedItems.length > 2"
          class="px-2 py-1 text-xs font-medium text-gray-500 bg-gray-100 rounded-full whitespace-nowrap"
        >
          +{{ selectedItems.length - 2 }}
        </div>
      </div>
      <div class="" v-else>{{ title }}</div>
      <BaseLoader size="size-5 min-w-5" v-if="loading" />
      <div v-else class="flex items-center justify-center text-gray-600">
        <Icon name="tabler:chevron-up" v-if="isOpen" size="20" />
        <Icon name="tabler:chevron-down" size="20" v-else />
      </div>
    </button>
    <div
      v-if="isOpen"
      class="fixed inset-0 z-99 flex items-center justify-center bg-black/25"
    ></div>
    <Transition
      enter-active-class="slideInUp"
      leave-active-class="slideOutDown"
    >
      <div
        v-if="isOpen"
        @click="isOpen = false"
        class="fixed inset-0 z-100 flex sm:items-center items-end justify-center bg-transparent"
      >
        <div
          @click.stop
          class="sm:w-96 w-full bg-white border border-gray-200 shadow-2xl sm:rounded-b-lg rounded-t-lg flex flex-col overflow-hidden"
          :class="[height]"
        >
          <div
            class="px-4 py-3 border-b border-gray-100 flex items-center justify-between bg-gray-50/50"
          >
            <span></span>
            <span class="font-semibold">{{ title }}</span>
            <button
              @click.stop="isOpen = false"
              type="button"
              class="size-7 min-w-7 flex items-center justify-center hover:bg-gray-200 cursor-pointer rounded-full transition-colors"
            >
              <Icon name="ph:x" size="16" />
            </button>
          </div>

          <div class="overflow-y-auto hover-scroll p-2">
            <div
              @click="selectItem(item)"
              class="p-2.5 cursor-pointer hover:bg-gray-100 rounded-xl flex items-center space-x-2"
              v-for="(item, index) in items"
              :key="item.id || index"
            >
              <div
                :class="
                  selectedItems?.some((i) => i.key === item.key)
                    ? 'bg-primary-blue'
                    : 'bg-white'
                "
                class="size-4.5 rounded min-w-4.5 border border-gray-200 flex items-center justify-center"
              >
                <Icon
                  name="ph:check"
                  size="12"
                  class="text-white"
                  v-if="selectedItems?.some((i) => i.key === item.key)"
                />
              </div>
              <span class="text-[15px]">{{ item.label[locale] }}</span>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useWindowSize } from "@vueuse/core";
import { cutName } from "../../utils/helpers";

const { width } = useWindowSize();
const { locale } = useI18n();

const emit = defineEmits(["select"]);

withDefaults(
  defineProps<{
    loading?: boolean;
    items?: any[];
    selectedItems?: any[];
    title?: string;
    position?: "bottom" | "top";
    height?: string;
    required?: boolean;
  }>(),
  {
    loading: false,
    title: "Select",
    items: () => ["Item 1 ", "Item 2", "Item 3"],
    position: "bottom",
    height: "h-auto",
    required: true,
  },
);

const isOpen = ref<boolean>(false);

const selectItem = (item: any) => {
  emit("select", item);
  //   isOpen.value = false;
};

const handleTitle = (t: string): string => {
  if (!t) return "";

  if (width.value > 700) t;
  if (width.value > 500) return cutName(t, 8);
  if (width.value > 200) return cutName(t, 5);

  return cutName(t, 3);
};
</script>
